module.exports = __webpack_public_path__ + "assets/asset_institution.00ec3859.svg";